//
import { PreparationStatus } from '@modules/OrderPreparation/shared/config';
import { usePackingFlow, usePrinterSelection, usePrintOrder } from '../../hooks';
import { usePackingContext } from '../../hooks/usePackingContext';
import {
  AddProductForm,
  Breadcrumb,
  OrderCompleteAlert,
  OrderForm,
  PackingProductsScreen,
  PrinterRequiredAlert,
  ProductForm,
} from '../display';
import { FloatingButtons } from '../interaction';

export const Main = () => {
  // Flujo de packing centralizado
  const {
    isPackingMode,
    selectedProduct,
    selectedOrder,
    assignedQuantities,
    completedOrder,
    isSendingOrder,
    selectProduct,
    addToPacking,
    exitPackingMode,
  } = usePackingFlow();

  const { data } = usePackingContext() as any;

  // 🎯 Verificar si hay una impresora seleccionada
  const { hasPrinterSelected } = usePrinterSelection();

  // 🎯 Hook para imprimir etiquetas
  const { printOrder, loading: isPrinting } = usePrintOrder();

  // Logs eliminados

  // Logs eliminados

  const handleAddProduct = (productCode: string, quantity: number) => {
    // Seleccionar la orden adecuada en base al producto y cantidades ya asignadas
    selectProduct(productCode);
    // Usar la orden decidida por el hook (puede ser diferente a la anterior si estaba completa)
    addToPacking(productCode, quantity, selectedOrder?.id);
  };

  const handleBackToSelection = () => {
    exitPackingMode();
  };

  return (
    <div className="p-6">
      {/* Breadcrumb */}
      <Breadcrumb />

      {/* Botones flotantes */}
      <FloatingButtons />

      {/* Alerta de impresora requerida */}
      {!hasPrinterSelected && <PrinterRequiredAlert />}

      {/* Formulario de agregar producto */}
      {(() => {
        // Regla: ocultar SOLO si la preparación está completa Y estamos en la pantalla principal.
        // Si estamos en la pantalla de packing (isPackingMode), debe ser visible aunque el estado sea COMPLETE.
        // También ocultar si no hay impresora seleccionada
        const isComplete = data?.preparation?.status === PreparationStatus.COMPLETE;
        const shouldRender = (isPackingMode || !isComplete) && hasPrinterSelected;
        return shouldRender ? (
          <AddProductForm
            onAddProduct={(code, qty) => handleAddProduct(code, qty)}
            maxQuantity={100}
            isInsideOrder={isPackingMode && !!selectedOrder}
            selectedOrder={selectedOrder}
            assignedQuantities={assignedQuantities}
            isSendingOrder={isSendingOrder}
          />
        ) : null;
      })()}

      {/* Alert de pedido completado (oculta cuando estamos dentro de una orden) */}
      {!!completedOrder && !isPackingMode && (
        <OrderCompleteAlert
          orderCode={completedOrder.ref}
          orderName={completedOrder.shop?.name}
          orderId={completedOrder.id}
          avatarSrc={completedOrder.shop?.image_hash}
          courierName={completedOrder.shipment?.courier?.name}
          courierImage={completedOrder.shipment?.courier?.image_hash}
          trackingNumber={completedOrder.shipment?.tracking_number}
          onPrint={async () => {
            if (completedOrder?.id) {
              await printOrder(completedOrder.id);
            }
          }}
          onPacking={() => {
            // TODO: Acción tras completar (navegar/listar)
          }}
        />
      )}

      {/* Contenido condicional */}
      {(() => {
        const shouldShowPackingScreen = isPackingMode;
        // Logs eliminados
        return shouldShowPackingScreen ? (
          /* Modo Packing - Mostrar PackingProductsScreen */
          <div className="mt-6">
            <PackingProductsScreen
              {...({
                selectedProduct,
                selectedOrder,
                assignedQuantities,
                onBack: handleBackToSelection,
                isSendingOrder,
              } as any)}
            />
          </div>
        ) : (
          /* Modo Selección - Mostrar ProductForm y OrderForm */
          <div className="flex gap-6 flex-col md:flex-row">
            {/* Productos del packing - 60% */}
            <div className="w-full md:w-3/5">
              <ProductForm />
            </div>

            {/* Pedidos - 40% */}
            <div className="w-full md:w-2/5">
              <OrderForm />
            </div>
          </div>
        );
      })()}
    </div>
  );
};
